/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 17:37:50
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-14 17:38:43
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/common.ts
 */

import _ from 'lodash';

const sortSales = (channels = []) => {
  return _.sortBy(channels, (c) => {
    return c.uuid;
  });
};

const sortLocales = (locales = []) => {
  return _.sortBy(locales, (c) => {
    return c.locale;
  });
};

const sortReviews = (reviews = []) => {
  return _.sortBy(reviews, (c) => {
    return c.uuid;
  });
};

enum EnumReviewType {
  All = 'All',
  Pending = 'Pending',
  Spam = 'Spam',
  Published = 'Published',
  Archive = 'Archive',
}

const sortList = ({ getI18n }) => [
  {
    label: getI18n('reviews.productreview.common_sortList_Rating(Highest)'),
    value: getI18n('reviews.productreview.common_sortList_Rating(Highest)'),
    data: { field: 'rating', ascent: false },
  },
  {
    label: getI18n('reviews.productreview.common_sortList_Rating(Lowest)'),
    value: getI18n('reviews.productreview.common_sortList_Rating(Lowest)'),
    data: { field: 'rating', ascent: true },
  },
  {
    label: getI18n('reviews.productreview.common_sortList_Uploaded(oldest)'),
    value: getI18n('reviews.productreview.common_sortList_Uploaded(oldest)'),
    data: { needMoment: true, field: 'createdDate', ascent: false },
  },
  {
    label: getI18n('reviews.productreview.common_sortList_Uploaded(latest)'),
    value: getI18n('reviews.productreview.common_sortList_Uploaded(latest)'),
    data: { needMoment: true, field: 'createdDate', ascent: true },
  },
];
export { EnumReviewType, sortList, sortLocales, sortReviews, sortSales };
